import { render, staticRenderFns } from "./DataProduct.vue?vue&type=template&id=c0637d82&scoped=true&"
import script from "./DataProduct.vue?vue&type=script&lang=js&"
export * from "./DataProduct.vue?vue&type=script&lang=js&"
import style0 from "./DataProduct.vue?vue&type=style&index=0&id=c0637d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0637d82",
  null
  
)

export default component.exports